import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaGstHst() {
  return (
    <SalonBusinessCpaTopicPage
      title="GST/HST"
      description="Track the sales tax records and filing details your salon needs for GST/HST support."
      sections={[
        {
          title: "Setup",
          body: "Confirm the basics before filing work begins.",
          items: ["Business number", "Filing frequency", "CRA online access status"],
        },
        {
          title: "Sales records",
          body: "Prepare the sales details that support your GST/HST return.",
          items: ["Service sales", "Product sales", "Gift card and deposit activity"],
        },
        {
          title: "Expense support",
          body: "Keep input tax credit records easy to review.",
          items: ["Supplier receipts", "Rent and utilities", "Software and payment fees"],
        },
      ]}
    />
  );
}
